import Head from "next/head"
import { usePathname } from "next/navigation"
import { type FunctionComponent, useContext } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { PUBLIC_LOCALES } from "@/modules/locales/constants"
import { useLocale } from "@/modules/locales/useLocale"
import { ServerContext } from "@/modules/server/context"

export const MetaData: FunctionComponent = () => {
  const currentLocale = useLocale()
  const { t } = useTranslation(["job_ads_fo"])
  const pathname = usePathname()
  const { baseUrl } = useContext(ServerContext) || { baseUrl: "" }

  return (
    <Head>
      <title>{t("job_ads_fo.client.search.meta.title")}</title>
      <meta name="description" content={t("job_ads_fo.client.search.meta.description")} />

      {PUBLIC_LOCALES.map(locale => {
        if (currentLocale === locale) {
          return null
        }

        return (
          <link
            key={locale}
            rel="alternate"
            href={`${baseUrl}/${locale}/job-offers?locale=${locale}`}
            hrefLang={locale}
          />
        )
      }).filter(Boolean)}

      <link rel="canonical" href={`${baseUrl}${pathname}?locale=${currentLocale}`} />
    </Head>
  )
}
